import React from 'react';
import deepmerge from 'deepmerge';
import { useTheme } from 'styled-components';
import { defaultChartOptions } from './defaultChartOptions.js';
export const useChartDefaultOptions = (overrides, deps = []) => {
    const theme = useTheme();
    const options = React.useMemo(() => {
        const defaultOptions = defaultChartOptions(theme);
        if (overrides) {
            return deepmerge(defaultOptions, overrides);
        }
        return defaultOptions;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...deps, theme]);
    return options;
};
